if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.boundHandleNavClick = this.handleNavClick.bind(this);
        this.boundHandleKeydown = this.handleKeydown.bind(this);
      }

      connectedCallback() {
        super.connectedCallback?.();
        this.#cacheElements();
        this.#bindEvents();
      }

      disconnectedCallback() {
        this.#unbindEvents();
      }

      hide() {
        this.removeEventListener('keydown', this.boundHandleKeydown);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.addEventListener('keydown', this.boundHandleKeydown);
        this.#setActiveMediaById(opener.getAttribute('data-media-id'));
      }

      showActiveMedia() {
        if (this.openedBy) {
          this.#setActiveMediaById(this.openedBy.getAttribute('data-media-id'));
        }
      }

      handleNavClick(event) {
        const navButton = event.target.closest('[data-modal-nav]');
        if (!navButton || navButton.disabled) return;

        event.stopPropagation();
        this.#navigate(navButton.dataset.modalNav);
      }

      handleKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.#navigate('prev');
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.#navigate('next');
        }
      }

      #cacheElements() {
        this.modalContent = this.querySelector('.product-media-modal__content');
        this.prevButton = this.querySelector('[data-modal-nav="prev"]');
        this.nextButton = this.querySelector('[data-modal-nav="next"]');
      }

      #bindEvents() {
        this.prevButton?.addEventListener('click', this.boundHandleNavClick);
        this.nextButton?.addEventListener('click', this.boundHandleNavClick);
      }

      #unbindEvents() {
        this.prevButton?.removeEventListener('click', this.boundHandleNavClick);
        this.nextButton?.removeEventListener('click', this.boundHandleNavClick);
      }

      #getMediaItems() {
        if (!this.modalContent) return [];

        return Array.from(this.modalContent.querySelectorAll(':scope > [data-media-id]'));
      }

      #getActiveIndex(mediaItems) {
        const activeIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        return activeIndex >= 0 ? activeIndex : 0;
      }

      #navigate(direction) {
        const mediaItems = this.#getMediaItems();
        if (mediaItems.length <= 1) return;

        let activeIndex = this.#getActiveIndex(mediaItems);

        if (direction === 'prev') {
          activeIndex = Math.max(0, activeIndex - 1);
        } else {
          activeIndex = Math.min(mediaItems.length - 1, activeIndex + 1);
        }

        this.#setActiveMediaById(mediaItems[activeIndex].getAttribute('data-media-id'));
      }

      #setActiveMediaById(mediaId) {
        if (!mediaId || !this.modalContent) return;

        const activeMediaId = String(mediaId);
        const mediaItems = this.modalContent.querySelectorAll('[data-media-id]');
        let activeMedia = null;

        mediaItems.forEach((item) => {
          const isActive = item.getAttribute('data-media-id') === activeMediaId;
          item.classList.toggle('active', isActive);

          if (isActive) {
            activeMedia = item;
          }
        });

        if (activeMedia) {
          const mediaTemplate = activeMedia.querySelector('template');
          const mediaContent = mediaTemplate ? mediaTemplate.content : null;

          if (activeMedia.nodeName === 'DEFERRED-MEDIA' && mediaContent && mediaContent.querySelector('.js-youtube')) {
            activeMedia.loadContent();
          }
        }

        this.#updateNavButtons();
        window.pauseAllMedia();
      }

      #updateNavButtons() {
        const mediaItems = this.#getMediaItems();
        const activeIndex = this.#getActiveIndex(mediaItems);
        const hasMultiple = mediaItems.length > 1;

        this.classList.toggle('is-single-media', !hasMultiple);

        if (this.prevButton) {
          this.prevButton.disabled = !hasMultiple || activeIndex === 0;
        }

        if (this.nextButton) {
          this.nextButton.disabled = !hasMultiple || activeIndex === mediaItems.length - 1;
        }
      }
    }
  );
}
